import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import CustomisedModal from "components/Application/CustomisedModal";

// import form validator
import SimpleReactValidator from "simple-react-validator";

// import custom validator
import {
  lessThanFileSizeValidator,
  fileTypeValidator,
} from "helpers/customValidator";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";
import { IMAGE_FILE_TYPE } from "helpers/constants";

import { fileCompress, filePreview } from "helpers/generalUtils";

import {
  getOfferListRequest,
  updateOfferStatusByOfferIdRequest,
  addOfferRequest,
  updateOfferByOfferIdRequest,
  getProductDetailListRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import { confirmBox, toastrMessage } from "helpers/messageHelper";

import { jsonToFormData } from "helpers/axiosRequestData";
import { makeOfferSelectField } from "store/OfferDetail/selector";
import { selectSortedProducts } from "store/ProductDetail/selector";
import { createStructuredSelector } from "reselect";

class OfferForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      offerData: offerDataInitialState(),
      imagePreview: null,
    };

    this.validator = new SimpleReactValidator({
      validators: Object.assign(
        lessThanFileSizeValidator(),
        fileTypeValidator()
      ),
    });
  }

  componentDidMount() {
    this.props.getProductDetailListRequest();
  }

  resetForm = (closeModal) => {
    this.setState({
      offerData: offerDataInitialState(),
      imagePreview: null,
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.offerApiResponse &&
      this.props.offerApiResponse !== nextprops.offerApiResponse
    ) {
      if (nextprops.offerApiResponse.isSuccessResponse) {
        this.props.getOfferListRequest();
        toastrMessage(nextprops.offerApiResponse.responseMessage, SUCCESS);
        this.resetForm(true);
      } else if (!nextprops.offerApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.offerApiResponse.responseMessage, DANGER);
      }
    }

    if (
      nextprops.offerRecord &&
      this.props.offerRecord !== nextprops.offerRecord
    ) {
      if (nextprops.offerRecord.offerDetailId) {
        this.setState({
          offerData: nextprops.offerRecord,
          operationType: UPDATE,
          imagePreview: nextprops.offerRecord.offerImageUrl,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  warningFileResolution = (file) => {
    return new Promise((resolve) => {
      if (!file) {
        resolve(true);
      }
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async function () {
        const width = this.naturalWidth,
          height = this.naturalHeight;

        const newHeight = Math.round(width * 0.4);
        if (
          Math.round(height) <= newHeight + 10 &&
          Math.round(height) >= newHeight - 10
        ) {
          resolve(true);
        } else {
          const res = await confirmBox(
            "Recommended Image Resolution is 5:2 ratio (1000px X 400px). Do you want to proceed?",
            ""
          );
          if (res) {
            resolve(true);
          }
          resolve(false);
        }
      };
    });
  };

  handleFilePreview = async (event, setFieldValue) => {
    // check if any one file is selected by user
    if (event.target.files.length > 0) {
      let file = event.target.files[0];

      await setFieldValue("offerImage", file);

      if (this.validator.fieldValid("offerImage")) {
        try {
          let response = await fileCompress(file, {
            maxSizeMB: 5,
            maxWidthOrHeight: 3000,
            useWebWorker: true,
          });
          await setFieldValue("offerImage", response);
          response = await filePreview(response);

          this.setState({ imagePreview: response });
        } catch (error) {
          this.setState({ imagePreview: null });
          setFieldValue("offerImage", "");
        }
      } else {
        this.setState({ imagePreview: null });
      }
    }
  };

  formSubmit = async (val) => {
    const values = {
      ...val
    }
    if (this.validator.allValid()) {
      const isValid = await this.warningFileResolution(values.offerImage);
      if (isValid) {
        // values.offerImage = ""
        this.setState({ offerData: values });
        if (this.state.operationType === UPDATE) {
          values.IsImageChanged = values.offerImage ? true : false;
          const data = jsonToFormData(values);
          this.props.updateOfferByOfferIdRequest(values.offerDetailId, data);
        } else {
          values.offerType = 1;
          const data = jsonToFormData(values);
          this.props.addOfferRequest(data);
        }
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Offer"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.offerData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Offer Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="offerName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "offerName",
                          values.offerName,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Select Products</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          component={Select}
                          name="productDetailIds"
                          defaultValue={values.productDetailIds.map(
                            (productId) =>
                              this.props.sortedProducts.find(
                                (product) => product.value === productId
                              )
                          )}
                          options={this.props.sortedProducts}
                          onChange={(opt, e) => {
                            setFieldValue("productDetailIds", [
                              ...opt.map((product) => product.value),
                            ]);
                          }}
                          isMulti
                        />
                        {this.validator.message(
                          "productDetailIds",
                          values.productDetailIds,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Offer Sequence</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="offerSeq"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Offer Sequence",
                          values.offerSeq,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Offer Image</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            name="offerImage"
                            accept="image/*"
                            onClick={(e) => (e.target.value = null)}
                            id="customFile"
                            onChange={(event) =>
                              this.handleFilePreview(event, setFieldValue)
                            }
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="customFile"
                          >
                            {values.offerImage
                              ? values.offerImage.name
                              : "Choose file"}
                          </label>
                        </div>
                        {this.validator.message(
                          "offerImage",
                          values.offerImage,
                          (this.state.operationType === SUBMIT
                            ? "required|"
                            : "") +
                            `lessThanFileSize:5242880|fileType:${IMAGE_FILE_TYPE}`
                        )}
                      </Col>
                    </Row>

                    {this.state.imagePreview && (
                      <Row className="form-group">
                        <Col sm="4" lg="3"></Col>
                        <Col sm="8" lg="5">
                          <img
                            className="img-thumbnail"
                            alt={values.offerName}
                            width="200"
                            src={this.state.imagePreview}
                            data-holder-rendered="true"
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  offerApiResponse: makeOfferSelectField("offerApiResponse"),
  sortedProducts: selectSortedProducts(),
});

const withConnect = connect(mapStatetoProps, {
  getOfferListRequest,
  updateOfferStatusByOfferIdRequest,
  addOfferRequest,
  updateOfferByOfferIdRequest,
  getProductDetailListRequest,
});

export default compose(withConnect, withRouter)(OfferForm);
//export default withRouter(withConnect)(Index);

function offerDataInitialState() {
  return {
    offerName: "",
    offerImage: "",
    offerSeq: "",
    productDetailIds: [],
  };
}
